import store from "../../../store";
import { CheckboxDropdownItem } from "../interfaces/settingsInterface";

export const getDepartmentIds = () => {
    const departments: CheckboxDropdownItem[] = store.getState().candidates.allDepartments
    const checked: CheckboxDropdownItem[] = store.getState().candidates.checkedDepartments
    let departmentIds: string[] = [];
    if (checked?.length) {
        checked.forEach(checkedItem => {
            // Find the corresponding department in the departments list
            const department = departments.find(department => department.key === checkedItem.key);
    
            if (department) {
                // Check if the number of checked children matches the department's total children
                const checkedChildren = checkedItem.children;
                const departmentChildren = department.children;
    
                if (checkedChildren?.length === departmentChildren?.length) {
                    // If the lengths are equal, add the parent's key and all children's keys
                    departmentIds.push(department.key);
                    departmentChildren?.forEach(child => departmentIds.push(child.key));
                } else {
                    // If the lengths are not equal, add only the checked children's keys
                    checkedChildren?.forEach(child => departmentIds.push(child.key));
                }
            }
        });
    
        return departmentIds.join(',');
    }
    return undefined
};